import {
    FormControl,
    InputBaseComponentProps
} from '@material-ui/core';
import {
    Alignment,
    HelperTextContainer,
    InputField,
    SelectLabel
} from '@components/field-builder/styles';
import { FunctionComponent } from 'react';
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import {
    Field,
    FieldDefinition
} from '@models/field-builder/field';

export interface IMaskFormatOptions {
    mask: Array<RegExp | string>;
    pipe: () => any;
}

export interface IMaskInputProps {
    mask: Array<RegExp | string>;
}

export const integerMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: ',',
    allowDecimal: false,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 9,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: false
};

export const decimalMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 9,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: false
};

export const usDateFormatOptions: IMaskFormatOptions = {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    pipe: createAutoCorrectedDatePipe('mm/dd/yyyy')
};

export const MaskInput: FunctionComponent<InputBaseComponentProps & IMaskInputProps> = (
    { inputRef, ...props }
) => {
    // @ts-ignore - work around for react-text-mask onFocus vs MaterialUI onFocus signatures
    return <MaskedInput ref={ref => {
        inputRef(ref ? ref.inputElement as HTMLInputElement : null);
    }} {...props} />;
};

export const FieldText = ({
                              id,
                              setValueMethod,
                              label,
                              // @ts-ignore
                              placeHolder = null,
                              width,
                              fullWidth,
                              labelPosition,
                              value,
                              hidden,
                              helperText,
                              maskOptions,
                              disabled,
                              hasError
                          }: Field) => {

    const getWidth = fullWidth ?
        '100%' :
        `${(width || FieldDefinition.defaultWidth)}px`;
    const handleChange = event => {
        event.preventDefault();
        if (!setValueMethod) {
            console.error(`No 'setValueMethod' found for the field: ${id}`);
            return;
        }
        setValueMethod(event.target.value);
    };

    return (
        <FormControl error={hasError}>
            <Alignment labelPosition={labelPosition} hidden={hidden}>
                <SelectLabel>{label}</SelectLabel>
                <InputField
                    name={id}
                    type={'text'}
                    placeholder={placeHolder}
                    width={getWidth}
                    autoComplete='off'
                    margin='dense'
                    disabled={disabled}
                    variant='outlined'
                    value={(value === undefined) ? '' : value}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true
                    }}
                    InputProps={{
                        // not proud of casting it to any
                        // but the typing mismatch has no other reasonable solution for now
                        inputProps: {
                            ...maskOptions,
                            mask: maskOptions?.mask || false
                        } as any,
                        inputComponent: MaskInput as any
                    }}
                />
            </Alignment>
            <HelperTextContainer>{helperText}</HelperTextContainer>
        </FormControl>
    );
};



// WEBPACK FOOTER //
// ./src/components/field-builder/field-text.tsx